import React, { useState, useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';

import PropertyCard from '../../../../../../../shared/components/Property/PropertyCard';
import { Map as LibMap, Label } from 'hosman-material';


const DesktopMap = ({ sale, properties }) => {
  const [selectedProperty, setSelectedProperty] = useState()
  const [map, setMap] = useState()
  const markerRefs = useRef(new Map());

  useEffect(() => {
    if (!map || !properties) return;

    markerRefs.current.clear();

    const markerElements = [];

    properties.forEach((property) => {
      const markerDiv = document.createElement('div');
      markerDiv.className = 'w-4 h-4 rounded-full border-2 border-white absolute cursor-pointer bg-ih-blue map-marker transition-colors';

      const handleMouseEnter = () => {
        setSelectedProperty(property);
      };

      const handleMouseLeave = () => {
        setSelectedProperty(null);
      };

      markerDiv.addEventListener('mouseenter', handleMouseEnter);
      markerDiv.addEventListener('mouseleave', handleMouseLeave);
      markerElements.push({ markerDiv, handleMouseEnter, handleMouseLeave });

      markerRefs.current.set(property.id, markerDiv);

      new mapboxgl.Marker(markerDiv)
        .setLngLat({ lat: property.lat, lng: property.lng })
        .addTo(map.current);
    });

    adaptMapZoomToProperties();

    return () => {
      markerElements.forEach(({ markerDiv, handleMouseEnter, handleMouseLeave }) => {
        markerDiv.removeEventListener('mouseenter', handleMouseEnter);
        markerDiv.removeEventListener('mouseleave', handleMouseLeave);
      });
      markerRefs.current.clear();
    };
  }, [map, properties]);

  useEffect(() => {
    markerRefs.current.forEach((el) => {
      el.classList.remove('bg-ih-indigo');
      el.classList.add('bg-ih-blue');
    });

    if (selectedProperty) {
      const selectedEl = markerRefs.current.get(selectedProperty.id);
      if (selectedEl) {
        selectedEl.classList.remove('bg-ih-blue');
        selectedEl.classList.add('bg-ih-indigo');
      }
    }
  }, [selectedProperty]);

  const adaptMapZoomToProperties = () => {
    const bounds = new mapboxgl.LngLatBounds();

    properties.forEach((property) => {
      bounds.extend([property.lng, property.lat]);
    });

    bounds.extend([sale.property.lng, sale.property.lat]);

    map.current.fitBounds(bounds, {
      padding: 50,
      maxZoom: 16,
      duration: 1000
    });

  }


  const displayZipCode = (property) => {
    if (!['Paris', 'Marseille', 'Lyon'].includes(property.city)) return null;

    return property.zip_code
  }

  if (properties.length < 1) return null;

  return (
    <div className='relative' data-testid='DesktopMap'>
      {process.env.NODE_ENV !== 'test' &&
        <LibMap
          accessToken={process.env.MAPBOX_PUBLIC_KEY}
          style={process.env.MAPBOX_STYLE_ADVERT}
          center={{ lat: sale.property.lat, lng: sale.property.lng }}
          zoom={14}
          sendMapToParent={setMap}
          marker
        />
      }

      {selectedProperty &&
        <div className='absolute -top-1 -right-1 w-72'>
          <PropertyCard
            property={selectedProperty}
            stateLabel={
              <div className='flex gap-2'>
                {selectedProperty.distance_from_relevant &&
                  <Label color='bg-ih-blue'>À {selectedProperty.distance_from_relevant}m</Label>
                }
                {selectedProperty.sale.advert_label_sold && <Label color='bg-ih-green'>Vendu</Label>}
              </div>
            }
            centerLabel={<Label color='bg-ih-indigo'>{selectedProperty.city} {displayZipCode(selectedProperty)}</Label>}
            price={selectedProperty.sale.price}
          />
        </div>
      }
    </div>
  );
}

export default DesktopMap;
